import { ReactNode } from "react";

import { Anchor, ExternalLinkSVG, Icon } from "@newsela/angelou";

import {
  descriptionCss,
  externalLinkIconCss,
  relativeContainerCss,
  rowAnchorCss,
  rowContainerCss,
  titleFlexRowCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/AppSwitcherMenu/PopoutRow/PopoutRow.styles";

const PopoutRow = ({
  TitleComponent,
  href,
  description,
  onKeyDown,
  label,
  dataQASelector,
}: IPopoutRow) => {
  return (
    <li css={relativeContainerCss}>
      <Anchor
        href={href}
        openInNewTab
        __cssFor={rowAnchorCss}
        ariaProps={{ "aria-label": label }}
        dataProps={{ "data-qa-selector": dataQASelector }}
        // @ts-expect-error typescript complaining about a generic usage of KeyboardEvent
        onKeyDown={onKeyDown}
      />

      <div css={rowContainerCss}>
        <div css={titleFlexRowCss}>
          {TitleComponent}
          <Icon SvgComponent={ExternalLinkSVG} __cssFor={externalLinkIconCss} />
        </div>

        <div css={descriptionCss}>{description}</div>
      </div>
    </li>
  );
};

interface IPopoutRow {
  href: string;
  label: string;
  description: string;
  dataQASelector: string;
  onKeyDown: (event: KeyboardEvent) => void;
  TitleComponent: ReactNode;
}

PopoutRow.displayName = "PopoutRow";
export { PopoutRow };
